export default "__VITE_ASSET__BHZ3iy1k__"